import UserIntro from '@/common/containers/UserIntro/UserIntro';

export default UserIntro;
